import { ORDER_URL } from './site';

/**
 * Promotion "Nouvelle saison".
 *
 * The discount is granted manually over WhatsApp, per customer — it is NOT
 * applied to the displayed prices. That is deliberate:
 *
 * The checkout is an external PHP endpoint where the query id *is* the price
 * (`order.php?id=29` = 29 €). Discounting on the site would require an
 * `order.php?id=<new price>` to exist for every discounted amount. Keeping the
 * list prices intact means every existing order link stays valid, and the
 * reduction is applied by hand at the point of contact.
 *
 * Flip `applyToPrices` to true only once the matching order.php ids exist.
 */

export const PROMO = {
  /** Show the season banner and its messaging. */
  active: true,
  /** Rewrite plan prices and order links. Requires new order.php ids first. */
  applyToPrices: false,
  discountEur: 10,
  label: 'Offre nouvelle saison',
  headline: 'La nouvelle saison commence',
  /** Timezone the daily countdown resets in — the audience is France/Belgium. */
  timeZone: 'Europe/Paris',
};

/** Message pre-filled in WhatsApp when a visitor claims the discount. */
export const PROMO_MESSAGE = `Bonjour, je souhaite profiter de l'offre nouvelle saison (-${PROMO.discountEur}€). Pouvez-vous m'indiquer les forfaits disponibles ?`;

/** Price after discount, as a fixed-2 string matching the original format. */
export function discountedPrice(price) {
  return (Number(price) - PROMO.discountEur).toFixed(2);
}

/** The order.php id for a price: the integer part, as used by the backend. */
export function orderId(price) {
  return String(Math.round(Number(price)));
}

export function orderLink(price) {
  return `${ORDER_URL}?id=${orderId(price)}`;
}

/**
 * Applies promo pricing to a plan — currently a no-op, because the discount is
 * handled manually (see the note at the top of this file). When enabled, the
 * plan keeps its list price in `originalPrice` for the strikethrough and its
 * `link` is regenerated so the checkout charges the displayed price.
 */
export function discountedPlan(plan) {
  if (!PROMO.active || !PROMO.applyToPrices) return plan;

  const newPrice = discountedPrice(plan.price);
  return {
    ...plan,
    originalPrice: plan.price,
    price: newPrice,
    link: orderLink(newPrice),
  };
}
